import { toast } from "sonner";
import request from "../../../helpers/request";

export type TRequestRptPtosPanorama = {
  idAlerta: string;
  reportType: string;
};

export const getRptAlertaDetalhe = async (data: TRequestRptPtosPanorama) => {
  if (!data.idAlerta) return null;
  if (typeof data.reportType === "undefined" || !data.reportType)
    return toast.error("Selecione um formato para baixar os relatórios.");
  const url = `${process.env.REACT_APP_API}/Relatorio/RptAlertaDetalhe?reportType=${data.reportType}&idAlerta=${data.idAlerta}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
